/**
 * Replace old selector with new in all instances CSS code:
 */

export default function( oldSelector = '', newSelector = '' ) {
	const cssCode = window.Stylist.codeEditor.getValue() // Get CSS code.
	oldSelector = oldSelector.replace( '.', '\\.' ) // Prepare for regex.

	// https://regex101.com/r/vRUjj2/9
	const regex = new RegExp( "(^)(?:" + oldSelector + ")(\\s*{[^{}]*})", "gm" )
	const subst = `$1` + newSelector + `$2`

	// The substituted value will be contained in the result variable
	return cssCode.replace( regex, subst )
}


// WEBPACK FOOTER //
// ./dev/stylist_parent/functions/replace-selector-in-css.js